import type {
  IssueWorkflowOutDto,
  WorkflowCreateInDto,
  WorkflowUpdateInDto,
} from 'shared/domain/workflow/types';

export interface IWorkflowUploader {
  POST: (url: string, data: WorkflowCreateInDto) => Promise<IssueWorkflowOutDto>;
  PUT: (url: string, data: WorkflowUpdateInDto) => Promise<IssueWorkflowOutDto>;
}

export type UploadWorkflow = (
  uploader: IWorkflowUploader,
  body: WorkflowCreateInDto,
  url: string
) => Promise<IssueWorkflowOutDto>;

export type UploadWorkflowChanges = (
  uploader: IWorkflowUploader,
  body: WorkflowUpdateInDto,
  url: string
) => Promise<IssueWorkflowOutDto>;

export function uploadWorkflow(
  uploader: IWorkflowUploader,
  body: WorkflowCreateInDto,
  url: string
): Promise<IssueWorkflowOutDto> {
  return uploader.POST(url, body);
}

export function uploadWorkflowChanges(
  uploader: IWorkflowUploader,
  body: WorkflowUpdateInDto,
  url: string
): Promise<IssueWorkflowOutDto> {
  return uploader.PUT(url, body);
}
